import { initFederation } from '@softarc/native-federation-orchestrator';
import { consoleLogger, globalThisStorageEntry, useDefaultImportMap } from '@softarc/native-federation-orchestrator/options';
import { appendNewImportMapKeys } from './app/core/federation/append-new-import-map-keys';
import { setRemoteModuleLoader } from './app/core/federation/remote-module-loader';
import { remoteManifest } from './app/core/federation/remotes';
import { startBootstrapDiagnostics } from './app/core/utils/bootstrap-diagnostics.util';
import { handleBootstrapFailure } from './app/core/utils/bootstrap-failure.util';
(window as any).__isMfeBuild = true;
startBootstrapDiagnostics();

const manifest = remoteManifest();

// Main entry point for Module Federation builds
// Always initializes federation to load import maps for shared packages.
// Native import maps (no es-module-shims shim mode) avoid the shim's blob: URL execution,
// which was desyncing DevTools breakpoints from source. es-module-shims' own polyfill mode
// (the default once shimMode isn't forced - see esmsInitOptions.shimMode: false in
// project.json) transparently falls back to full polyfilling per-browser, so no custom
// feature detection is needed here.
//
// Keep this a plain dynamic import, not `importShim(...)`: esbuild statically resolves and
// rewrites `import('./bootstrap')` to its real hashed chunk path at build time, which it
// cannot do for a call it doesn't recognise as an import expression. bootstrap.ts's
// federation-shared imports (@angular/core etc.) are all static at its top level, so a
// browser without native import map support hits a static link-time failure there - which
// the polyfill IS able to catch and reexecute, unlike a genuinely unresolvable dynamic
// import() specifier (which this isn't: './bootstrap' is a plain relative path, not a
// federation-shared specifier, so it never needs the import map to resolve).
initFederation(manifest, {
    ...useDefaultImportMap(),
    // Host shared deps are inlined into index.html at build time (BX-23098). initFederation
    // still calls setImportMapFn with the FULL combined map and override:true - re-registering
    // those same keys (or deleting the inlined map) null-blocks them in the browser. Append
    // only keys the inlined map does not already have, which is how remotes contribute
    // packages the host never shared (e.g. stream-chat from mfe-messages).
    setImportMapFn: appendNewImportMapKeys,
    logger: consoleLogger,
    storage: globalThisStorageEntry,
    hostRemoteEntry: './remoteEntry.json',
    logLevel: 'debug',
})
    .then((federation) => {
        setRemoteModuleLoader(federation);
        return import('./bootstrap');
    })
    .catch((err) => handleBootstrapFailure(err, (specifier) => import.meta.resolve(specifier)));
